<template>
  <div class="wrapper main-container">
    <div class="top">
      <Button
        class="btn"
        v-if="totalList.status == 1 && userType != 3 && mode == 1"
        type="primary"
        :disabled="!productList || productList.length == 0"
        @click="handleRewardDetail(totalList.actId)"
        >单独配置奖励</Button
      >
      <div class="imgbox">
        <img :src="totalList.img" alt />
        <div class="mask" v-if="totalList.status == 3">活动已结束</div>
      </div>
      <div class="txtBox">
        <h1>
          <span>{{ totalList.title }}</span>
          <div class="status unStart" v-if="totalList.status == 1">未开始</div>
          <div class="status starting" v-else-if="totalList.status == 2">进行中</div>
          <div class="status end" v-else>已结束</div>
        </h1>
        <p>{{ totalList.description }}</p>
        <p class="actTime">活动时间：{{ totalList.startTime }} 至 {{ totalList.endTime }}</p>
        <div class="time">
          <span class="text3" v-if="totalList.timeStatus == 0">距离开始还剩：</span>
          <span class="text3" v-if="totalList.timeStatus == 1">距离结束还剩：</span>
          <span class="text4" v-if="totalList.timeStatus == 0 || totalList.timeStatus == 1">{{ totalList.timeText }}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="tabContent">
        <Tabs v-model="tab" @on-click="changeTabs">
          <TabPane label="活动详情" name="1"></TabPane>
          <TabPane label="参与详情" name="2"></TabPane>
        </Tabs>
        <Button type="primary" ghost class="backBtn" @click="back('/activityManage')">返回</Button>
      </div>
      <loading :isShow="loading" />
      <div class="detail" v-show="tab == 1">
        <div class="textBox">
          <div class="item">
            <span class="label">活动时间：</span>
            <span>{{ totalList.startTime }} 至 {{ totalList.endTime }}</span>
          </div>
          <div class="item" v-if="mode == 2">
            <span class="label">活动规则：</span>
            <span v-html="rule"></span>
          </div>
          <template v-if="mode == 1">
            <div class="item" v-if="userType != 3">
              <span class="label">奖励分配规则：</span>
              <span class="bold">
                请您于
                <em>{{ totalList.yesteTime }}17点</em>
                <span>前单独配置此产品奖金发放比例，如果未单独配置，将默认按照新活动预设服务费比例进行分配，如果未开启新活动预设服务费比例，</span>
                <span v-if="rewardType == 0 || totalList.status == 1">奖励默认全部发放给业务员。</span>
                <span v-else-if="rewardType == 1">奖励按照新活动预设服务费进行分配。</span>
                <span v-else-if="rewardType == 2">奖励按照商户配置进行分配。</span>
              </span>
            </div>
            <div class="item">
              <span class="label">奖励发放规则：</span>
              <span>
                <ul>
                  <li>1、长险过犹豫期且执回访成功后，在结算周期内，与基础服务费一同结算；</li>
                  <li>2、短险生效后在结算周期内，与基础推广费同时结算；</li>
                  <li>3、加费奖励仅计算主险首年奖励。</li>
                </ul>
              </span>
            </div>
            <div class="item" :class="{ 'active': userType == 3 ? false : zkFlag }">
              <span class="label">奖励结算规则：</span>
              <span>活动开始后，平台会根据活动的具体情况于次月15日进行结算，如产生退保，不予发放奖励；若已发放，则奖励与基础推广费一并追回。</span>
            </div>
            <div class="item" :class="{ 'active': zkFlag }">
              <span class="label">活动声明：</span>
              <span>活动期间如有恶意退保、刷单、造成客户投诉，平台有权终止该商户活动。在法律解释范围内，本活动最终解释权归{{ $config.appName }}所有。</span>
            </div>
            <div class="zkBtn" :class="{ 'zkActive': !zkFlag }" @click="zkFlag = !zkFlag">{{ zkFlag ? '展开' : '收起' }}<Icon type="ios-arrow-down" /></div>
          </template>
        </div>
        <div class="tableList">
          <div class="item table-box" v-for="(item, index) in productList" :key="index">
            <div class="tableHead">
              <img :src="item.companyIcon" alt />
              <span class="tag">{{ item.productType | filterProductType }}</span>
              <span class="title">{{ item.productName }}</span>
            </div>
            <Table :columns="columns2" :data="item.commissions">
              <template v-if="userType != 3" slot-scope="{ row }" slot="totalReward">
                <div>
                  {{ row.totalReward.commission }}
                </div>
              </template>
              <template v-if="userType != 3" slot-scope="{ row }" slot="companyReward">
                <div>
                  {{ row.companyReward.commission }}
                </div>
              </template>
              <template slot-scope="{ row }" slot="salesReward">
                <div>
                  {{ row.salesReward.commission }}
                </div>
              </template>
            </Table>
          </div>
        </div>
      </div>
      <div class="tongji" v-show="tab == 2 && mode == 1">
        <div class="empty" v-if="totalList.status == 1">
          <p>
            <img src="@static/images/noData.png" style="width: 290px" />
          </p>
          <p><span>活动未开始，暂无数据</span></p>
        </div>
        <div class="tableList" v-if="totalList.status != 1">
          <div class="tableHead">
            <span>
              共
              <em class="blue" v-if="statistics">{{ statistics.policyCount }}件</em>
              <em class="blue" v-else>{{ 0 }}件</em>
            </span>
            <span>
              保费总计：
              <em v-if="statistics">{{ statistics.totalFee }}元</em>
              <em v-else>{{ 0 }}元</em>
            </span>
            <span>
              机构净收入：
              <em v-if="statistics">{{ statistics.orgNetIncome }}元</em>
              <em v-else>{{ 0 }}元</em>
            </span>
            <span v-if="userType != 3">
              机构奖励：
              <em v-if="statistics">{{ statistics.companyReward }}元</em>
              <em v-else>{{ 0 }}元</em>
            </span>
            <span>
              业务员奖励：
              <em v-if="statistics">{{ statistics.agencyReward }}元</em>
              <em v-else>{{ 0 }}元</em>
            </span>
            <div class="btn" @click="exportToExcel">导出</div>
          </div>
          <div class="table-box">
            <Table :columns="columns_other" :data="statisticsDetails"></Table>
          </div>
        </div>
      </div>

      <div class="tongji" v-show="tab == 2 && mode == 2">
        <div class="empty" v-if="totalList.status == 1">
          <p>
            <img src="@static/images/noData.png" style="width: 290px" />
          </p>
          <p><span>活动未开始，暂无数据</span></p>
        </div>
        <div class="tableList" v-if="totalList.status != 1">
          <div class="tableHead">
            <span>
              保单数：
              <em class="blue">{{ gradientStatisticsData.policyNum }}单</em>
            </span>
            <span>
              规模保费：
              <em>{{ gradientStatisticsData.totalFee }}元</em>
            </span>

            <span>
              标准保费：
              <em>{{ gradientStatisticsData.totalFoldFyb }}元</em>
            </span>

            <span>
              预计活动奖励：
              <em>{{ gradientStatisticsData.predictActReward }}元</em>
            </span>
            <div class="btn" @click="exportGradientToExcel">导出</div>
          </div>
          <div class="table-box">
            <loading :isShow="listLoading" />
            <Table :columns="gradientColumns" :data="gradientTableData">
              <template slot-scope="{ row }" slot="settlementSlot">
                <div class="status">
                  <div class="item error" v-if="row.settlementStatus == '0'">待结算</div>
                  <div class="item success" v-else>已结算</div>
                </div>
              </template>
            </Table>
          </div>
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="changePageSize" style="text-align: center" />
        </div>
      </div>
    </div>
    <!-- 单独配置奖励 -->
    <Modal v-model="showOther" @on-ok="confirmOther" width="940" class="otherBox">
      <div slot="header" class="actBoxHeader">
        <h1>单独配置奖励</h1>
      </div>
      <loading :isShow="modaLoading" />
      <div class="content" v-for="(reward, r) in rewardDetailList" :key="r">
        <div class="title">
          <span>{{ reward.productType | filterProductType }}</span>
          <span>{{ reward.productName }}</span>
        </div>
        <div class="tableBox setTable">
          <Table :columns="columns_modal" :data="reward.commissions">
            <template slot-scope="{ row }" slot="totalReward">
              <div>
                {{ row.totalReward.commission }}
              </div>
            </template>
            <template slot-scope="{ index }" slot="companyReward">
              <div>
                {{
                  (reward.commissions[index].companyReward.commission =
                    reward.commissions[index].totalReward.commission - reward.commissions[index].salesReward.commission)
                }}
              </div>
            </template>
            <template slot-scope="{ index }" slot="action">
              <div class="actionBox">
                <span
                  class="subtraction"
                  @click="subtraction(reward.commissions[index])"
                  :class="{ notAllow: reward.commissions[index].salesReward.commission <= 0 }"
                  >-</span
                >
                <InputNumber
                  :precision="0"
                  :min="0"
                  :max="reward.commissions[index].totalReward.commission"
                  v-model="reward.commissions[index].salesReward.commission"
                  style="width: 160px; margin: 0 10px"
                />
                <span
                  class="add"
                  @click="add(reward.commissions[index])"
                  :class="{ notAllow: reward.commissions[index].salesReward.commission >= reward.commissions[index].totalReward.commission }"
                  >+</span
                >
              </div>
            </template>
          </Table>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import filters from '@/api/filter';

export default {
  mixins: [common],
  data() {
    return {
      rewardType: '', // 0 奖励默认全部发放给业务员,1 奖励按照新活动预设服务费进行分配,2奖励按照商户配置进行分配
      userType: '',
      rewardDetailList: [],
      modaLoading: false,
      activeid: '',
      showOther: false,
      loading: false,
      zkFlag: true,
      tab: '1',
      columns2: [],
      columns_other: [],
      columns: [
        {
          title: '保障期',
          key: 'guaranteeDesc',
          align: 'center'
        },
        {
          title: '交费期',
          key: 'payDesc',
          align: 'center'
        },
        {
          title: '活动总奖励(%)',
          key: 'totalReward',
          slot: 'totalReward',
          align: 'center'
        },
        {
          title: '机构奖励(%)',
          key: 'companyReward',
          slot: 'companyReward',
          align: 'center'
        },
        {
          title: '业务员奖励(%)',
          key: 'salesReward',
          slot: 'salesReward',
          align: 'center'
        }
      ],
      columns1: [
        {
          title: '保障期',
          key: 'guaranteeDesc',
          align: 'center'
        },
        {
          title: '交费期',
          key: 'payDesc',
          align: 'center'
        },
        {
          title: '业务员奖励(%)',
          key: 'salesReward',
          slot: 'salesReward',
          align: 'center'
        }
      ],
      columns_other1: [
        {
          title: '产品名称',
          key: 'productName',
          align: 'center'
        },
        {
          title: '保单(件)',
          key: 'policyCount',
          align: 'center'
        },
        {
          title: '保费(元)',
          key: 'totalFee',
          align: 'center'
        },
        {
          title: '机构净收入(元)',
          key: 'orgNetIncome',
          align: 'center'
        },
        {
          title: '机构奖励(元)',
          key: 'companyReward',
          align: 'center'
        },
        {
          title: '业务员奖励(元)',
          key: 'agencyReward',
          align: 'center'
        }
      ],
      columns_other2: [
        {
          title: '产品名称',
          key: 'productName',
          align: 'center'
        },
        {
          title: '保单(件)',
          key: 'policyCount',
          align: 'center'
        },
        {
          title: '保费(元)',
          key: 'totalFee',
          align: 'center'
        },
        {
          title: '机构净收入(元)',
          key: 'orgNetIncome',
          align: 'center'
        },
        {
          title: '业务员奖励(元)',
          key: 'agencyReward',
          align: 'center'
        }
      ],
      columns_modal: [
        {
          title: '保障期',
          key: 'guaranteeDesc',
          align: 'center'
        },

        {
          title: '交费期',
          key: 'payDesc',
          align: 'center'
        },
        {
          title: '活动总奖励(%)',
          key: 'totalReward',
          slot: 'totalReward',
          align: 'center'
        },
        {
          title: '机构奖励(%)',
          slot: 'companyReward',
          key: 'companyReward',
          align: 'center'
        },
        {
          title: '业务员奖励(%)',
          slot: 'action',
          key: 'salesReward',
          align: 'center',
          width: '260'
        }
      ],
      totalList: {}, //所有数据
      productList: [], //产品列表
      statistics: {}, //活动统计
      statisticsDetails: [], //活动统计详情
      commissionList: [], // 费用奖励列表
      rule: '',
      id: '',
      mode: '',
      actType: '',
      gradientStatisticsData: {}, //梯度统计
      listLoading: false,
      gradientTableData: [], //梯度列表数据
      gradientColumns: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    };
  },
  methods: {
    // 获取活动详情
    getActiveDetail(id) {
      this.loading = true;
      this.$http({
        url: '/buz/activity/org/detail',
        type: 'GET',
        data: {
          id: id
        }
      })
        .then(res => {
          this.loading = false;
          this.totalList = res.data;
          this.productList = res.data.productList;
          this.statistics = res.data.statistics;
          this.rewardType = res.data.rewardType;
          this.statisticsDetails = res.data.statisticsDetails;
          this.rule = res.data.rule;
          this.getEndTime(this.totalList);
          this.getYesterDay(this.totalList);
          console.log('this.totalList', this.totalList);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    subtraction(row) {
      if (row.salesReward.commission <= 0) {
        return;
      }
      row.salesReward.commission = row.salesReward.commission * 1 - 1;
    },
    add(row) {
      if (row.salesReward.commission >= row.totalReward.commission) {
        return;
      }
      row.salesReward.commission = row.salesReward.commission * 1 + 1;
    },
    // 奖励详情
    handleRewardDetail(id) {
      this.activeid = id;
      this.showOther = true;
      this.modaLoading = true;
      this.$http({
        url: '/buz/activity/commission/detail',
        type: 'GET',
        data: {
          id: id
        }
      })
        .then(res => {
          this.modaLoading = false;
          this.rewardDetailList = res.data;
          this.rewardDetailList.map(item => {
            item.commissions.map(resp => {
              resp.totalReward.commission = Number(resp.totalReward.commission);
              resp.companyReward.commission = Number(resp.companyReward.commission);
              resp.salesReward.commission = Number(resp.salesReward.commission);
            });
          });
        })
        .catch(e => {
          this.modaLoading = false;
        });
    },
    //单独配置
    confirmOther() {
      this.modaLoading = true;
      let item = [];
      this.rewardDetailList.map(res => {
        res.commissions.map(com => {
          item.push(com.companyReward);
          item.push(com.salesReward);
        });
      });
      this.$http({
        url: '/buz/actCommission/updateOrgCommission',
        type: 'post',
        data: {
          actId: this.activeid,
          items: item
        }
      })
        .then(res => {
          this.modaLoading = false;
          if (res.httpCode == 1) {
            this.$notice.success('修改成功');
            this.getActiveDetail(this.id);
          }
        })
        .catch(e => {
          this.modaLoading = false;
        });
    },
    // 活动单导出
    exportToExcel() {
      this.loading = true;
      this.$http({
        url: '/buz/activity/org/export',
        type: 'GET',
        responseType: 'blob',
        data: {
          id: this.totalList.actId
        }
      })
        .then(res => {
          this.loading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 切换详情tabs
    changeTabs(v) {
      if (v == 2) {
        if (this.actType == 3 || this.actType == 5) {
          this.gradientColumns = [
            {
              title: '序号',
              type: 'index',
              align: 'center',
              width: 80
            },
            {
              title: '保单号',
              key: 'policyNo',
              align: 'center',
              minWidth: 120
            },
            {
              title: '产品名称',
              key: 'productName',
              align: 'center',
              minWidth: 300
            },
            {
              title: '出单业务员',
              key: 'salesmanName',
              align: 'center',
              minWidth: 100
            },
            {
              title: '出单机构',
              align: 'center',
              key: 'orgName',
              minWidth: 200
            },
            {
              title: '保障期',
              key: 'guaranteeValueDesc',
              align: 'center',
              minWidth: 100
            },
            {
              title: '缴费期',
              key: 'payValueDesc',
              align: 'center',
              minWidth: 100
            },
            {
              title: '是否含身故',
              key: 'includingDeath',
              align: 'center',
              minWidth: 100,
              render(h, params) {
                return <span>{params.row.includingDeath ? params.row.includingDeath : '-'}</span>;
              }
            },
            {
              title: '标准保费',
              key: 'foldFyb',
              align: 'center',
              minWidth: 100
            },
            {
              title: '规摸保费',
              key: 'fee',
              align: 'center',
              minWidth: 100
            },
            {
              title: '结算状态',
              align: 'center',
              minWidth: 120,
              slot: 'settlementSlot'
            }
          ];
        } else if (this.actType == 4) {
          this.gradientColumns = [
            {
              title: '序号',
              type: 'index',
              align: 'center',
              width: 80
            },
            {
              title: '保单号',
              key: 'policyNo',
              align: 'center',
              minWidth: 120
            },
            {
              title: '保单状态',
              align: 'center',
              minWidth: 120,
              render(h, params) {
                let policyStatus = params.row.policyStatus;
                if (policyStatus == '1') {
                  return <span>已承保</span>;
                } else if (policyStatus == '-1') {
                  return <span>已退保</span>;
                } else if (policyStatus == '0') {
                  return <span>已终止</span>;
                } else if (policyStatus == '2') {
                  return <span>已中止</span>;
                }
              }
            },
            {
              title: '险种名称',
              key: 'productName',
              align: 'center',
              minWidth: 160
            },
            {
              title: '出单业务员',
              key: 'salesmanName',
              align: 'center',
              minWidth: 100
            },
            {
              title: '所属机构',
              key: 'orgName',
              align: 'center',
              minWidth: 100
            },
            {
              title: '所属团队',
              key: 'groupName',
              align: 'center',
              minWidth: 100
            },
            {
              title: '标准保费',
              key: 'foldFyb',
              align: 'center',
              minWidth: 100
            },
            {
              title: '规摸保费',
              key: 'fee',
              align: 'center',
              minWidth: 100
            },
            {
              title: '回执状态',
              key: 'receiptStatus',
              align: 'center',
              minWidth: 100,
              render(h, params) {
                if (params.row.receiptStatus == '-1') {
                  return <span>无需回执</span>;
                } else if (params.row.receiptStatus == '0') {
                  return <span>待回执</span>;
                } else if (params.row.receiptStatus == '1') {
                  return <span>回执成功</span>;
                } else if (params.row.receiptStatus == '2') {
                  return <span>回执失败</span>;
                } else {
                  return <span>-</span>;
                }
              }
            },
            {
              title: '回访状态',
              key: 'verifyStatus',
              align: 'center',
              minWidth: 100,
              ellipsis: true,
              tooltip: true,
              render(h, params) {
                if (params.row.verifyStatus == '0') {
                  return <span>待回访</span>;
                } else if (params.row.verifyStatus == '1') {
                  return <span>回访成功</span>;
                } else if (params.row.verifyStatus == '2') {
                  return <span>回访失败</span>;
                } else if (params.row.verifyStatus == '3') {
                  return <span>无需回访</span>;
                } else {
                  return <span>-</span>;
                }
              }
            },
            {
              title: '犹豫期截止日期',
              key: 'hesitateDate',
              align: 'center',
              minWidth: 120,
              render(h, params) {
                return <span>{filters.filterTime(params.row.hesitateDate, 'YYYY-MM-DD')}</span>;
              }
            }
          ];
        }
        this.getGradientStatistics();
        this.getGradientList();
      }
    },
    // 梯度详情列表
    getGradientList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/activity/org/queryActPolicyList',
        type: 'POST',
        data: {
          actId: this.totalList.actId,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.listLoading = false;
          this.total = res.total;
          this.gradientTableData = res.data;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    changePageSize(num) {
      this.pageNum = num;
      this.getGradientList();
    },
    // 获取梯度统计
    getGradientStatistics() {
      this.$http({
        url: '/buz/activity/org/queryActJoinCount',
        type: 'POST',
        data: {
          actId: this.totalList.actId
        }
      }).then(res => {
        this.gradientStatisticsData = res.data;
      });
    },
    // 梯度导出
    exportGradientToExcel() {
      this.$units.downloadFile('/buz/activity/org/exportActPolicyList', { actId: this.totalList.actId }, 'POST');
    },
    getYesterDay(time) {
      if (time.startTime) {
        time.yesteTime = this.getNextDate(time.startTime, -1);
      }
    },
    // date 代表指定的日期字符串 2021-05-20 00:00:00
    // day 传-1表始前一天，传1表始后一天
    // JS获取指定日期的前一天，后一天
    getNextDate(date, day) {
      var dd = new Date(Date.parse(date));
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
      return `${y}年${m}月${d}日`;
    },
    // 接口返回数据处理
    // 设置倒计时时间
    getEndTime(item) {
      const now = new Date().getTime();
      const time = new Date(item.startTime).getTime();
      const eTime = new Date(item.endTime).getTime();
      if (eTime < now) {
        this.$set(item, 'timeStatus', '-1');
      } else if (time < now) {
        this.$set(item, 'timeStatus', '1');
        this.getTimeText(item, now, eTime);
      } else {
        this.$set(item, 'timeStatus', '0');
        this.getTimeText(item, now, time);
      }
    },
    //设置倒计时时间格式
    getTimeText(item, stiem, etime) {
      let text = '';
      const m = parseInt((etime - stiem) / 1000 / 60);
      if (parseInt((m / 60) % 24) != 0) {
        text = parseInt((m / 60) % 24) + '小时';
      }
      if (parseInt(m / 60 / 24) != 0) {
        text = parseInt(m / 60 / 24) + '天' + text;
      } else {
        text = text + parseInt(m % 60) + '分钟';
      }
      this.$set(item, 'timeText', text);
    }
  },
  mounted() {
    let { id, mode, actType } = this.$route.query;
    this.id = id;
    this.mode = mode;
    this.actType = actType;
    this.userType = JSON.parse(localStorage.getItem('userInfo')).userType;

    if (this.userType != 3) {
      this.columns2 = this.columns;
      this.columns_other = this.columns_other1;
    } else {
      this.columns2 = this.columns1;
      this.columns_other = this.columns_other2;
    }
    if (mode == 2) {
      this.columns2 = this.columns2.filter(item => item.key != 'companyReward' && item.key != 'salesReward' && item.key != 'totalReward');
      this.columns2.push(
        {
          title: '区域',
          align: 'center',
          key: 'region',
          minWidth: 120,
          render(h, params) {
            return <span>{params.row.region ? params.row && JSON.parse(params.row.region).join('，') : '-'}</span>;
          }
        },
        {
          title: '是否含身故',
          key: 'includingDeath',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            return <span>{params.row.includingDeath ? params.row.includingDeath : '-'}</span>;
          }
        },
        {
          title: '保额',
          key: 'insuredAmount',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            return <span>{params.row.insuredAmount ? params.row.insuredAmount : '-'}</span>;
          }
        }
      );
    }
    this.getActiveDetail(this.id);
  },
  filters: {
    filterProductType(val) {
      if (!val) {
        return '';
      } else if (val == 1) {
        return '长险';
      } else if (val == 2) {
        return '短险';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
